import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';

import { SectionHeader_2 } from '../../../../../component/landingComponent';
const LmHowDoWeDoIt = () => {
    return (
        <div className='row px-10 mb-20'>
            <div className='col-md-12 text-center'>
                <SectionHeader_2
                    title= {`How we do it?`}
                />
            </div>
            <div className='row mt-20 border px-10 br-20'>
                <div className='col-md-7 pe-15 m-auto'>
                    <div className='mt-6'>
                        <ul className="list-check ">
                            <li className='d-flex text-gray-700 fs-3 mt-10'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                <div>
                                    <div>
                                        TruVoice Generative AI <sup style={{ fontSize: '0.6em', verticalAlign: 'baseline', position: 'relative', top: '-0.9em' }}>‘Pat.Pend.’</sup> is a deterministic language model that generates synthetic data with accurate examples as per the specified domain requirements.
                                    </div>
                                </div>
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                We may optionally augment this data with pre-trained LLMs – open source or custom built, to build custom language models, as per need.
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                Our models produce high accuracy and low hallucination, suitable for commercial implementations
                            </li>
                            <li className='d-flex text-gray-700 fs-3'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                We add <u style={{ margin: '0 4px', display: 'inline-block' }}>‘Transformers’</u> layer to enhance the models.
                            </li>
                            <li className='d-flex text-gray-700 fs-3 mb-10'>
                                <FontAwesomeIcon icon={faCircleCheck} className='me-2'/>
                                These models are reliable with high accuracy and low hallucination, which is suitable for commercial implementations.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-5 text-end m-auto'>
                    <img src="/assets/img/developer-guide.jpg" alt="app image" className="radius-20 p-10 pe-0" style={{}} />
                </div>
            </div>
        </div>
    )
}

export {LmHowDoWeDoIt}